import { DatapointStatus, PerformanceDatapoint, logUsage } from 'owa-analytics';
import { getGuid } from 'owa-guid';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import { makePostRequest } from 'owa-ows-gateway';

import getEntryPoint from '../selectors/getEntryPoint';
import { getUserMailboxGuid } from '../utils/getMailboxGuid';
import getMailboxPuid from '../selectors/getMailboxPuid';
import { getUserConfiguration } from 'owa-session-store';
import getPageOrigin from '../selectors/getPageOrigin';

import type MeetingTypeExtension from './schema/MeetingTypeExtension';
export default async function createMeetingTypeExtension(
    MeetingTypeExtension: MeetingTypeExtension
): Promise<boolean> {
    const url = 'ows/beta/BookWithMe/CreateMeetingTypeExtension';
    const meTileEntryPoint = 'meTile';
    const perfDatapoint = new PerformanceDatapoint('createMeetingTypeExtension');
    perfDatapoint.addCustomData({
        entryPoint: getEntryPoint(),
        mailboxGuid: getUserMailboxGuid(),
        bookingMailboxPuid: getMailboxPuid(),
        pageOrigin: getPageOrigin(),
    });
    /* eslint-disable-next-line owa-custom-rules/require-mailboxInfoInOwsRequest  -- (https://aka.ms/OWALintWiki)
     * MailboxInfo must be providded to OWS calls, see https://aka.ms/multiaccountlinter
     *	> All OWS calls must pass in a MailboxInfo or OwsRequestOptions obtained via getOwsMailboxRequestOptions. */
    const response = await makePostRequest(
        url,
        {
            MeetingTypeExtension,
        },
        getGuid() /*correlationId*/,
        true /*returnFullResponse*/,
        undefined /*customHeaders */,
        false /* throwServiceError*/,
        false /* sendPayloadAsBody*/,
        false /*includeCredentials*/,
        'createMeetingTypeExtension' /*actionName*/
    );

    if (isSuccessStatusCode(response.status)) {
        perfDatapoint.addCustomData({
            meetingTypeId: MeetingTypeExtension.itemId,
            displayName: MeetingTypeExtension.displayName,
            isPrivate: MeetingTypeExtension.isPrivate,
        });
        perfDatapoint.end();
        if (
            getEntryPoint() === meTileEntryPoint &&
            !getUserConfiguration()?.ViewStateConfiguration?.SelectedBookingMailbox
        ) {
            // Capture event when new user (wrt shared bookings) creates meeting type via metile
            logUsage('MeTileCreateMeetingTypeNewSharedBookingUser');
        }
        return true;
    } else {
        perfDatapoint.addCustomData({
            meetingTypeId: MeetingTypeExtension.itemId,
            displayName: MeetingTypeExtension.displayName,
            isPrivate: MeetingTypeExtension.isPrivate,
        });
        perfDatapoint.endWithError(DatapointStatus.ServerError);
        return false;
    }
}
